module.exports = function() {
  return new Worker(__webpack_public_path__ + "2bd584aa5041ca03e6d1.worker.js");
};